<template>
  <div class="detail-skeleton">
    <!-- 标题骨架 -->
    <div class="detail-skeleton__title"></div>

    <!-- Meta 骨架 -->
    <div class="detail-skeleton__meta">
      <div class="detail-skeleton__text detail-skeleton__text--sm"></div>
      <div class="detail-skeleton__text detail-skeleton__text--sm"></div>
      <div class="detail-skeleton__text detail-skeleton__text--md"></div>
    </div>

    <!-- 配图骨架 -->
    <div class="detail-skeleton__image"></div>

    <!-- 正文骨架 -->
    <div class="detail-skeleton__content">
      <div class="detail-skeleton__line"></div>
      <div class="detail-skeleton__line"></div>
      <div class="detail-skeleton__line detail-skeleton__line--short"></div>
      <div class="detail-skeleton__line"></div>
      <div class="detail-skeleton__line detail-skeleton__line--short"></div>
    </div>

    <!-- 评论标题骨架 -->
    <div class="detail-skeleton__comment-title"></div>

    <!-- 评论列表骨架 -->
    <div class="detail-skeleton__comments">
      <div v-for="n in 3" :key="n" class="detail-skeleton__comment">
        <div class="detail-skeleton__avatar"></div>
        <div class="detail-skeleton__comment-body">
          <div class="detail-skeleton__text detail-skeleton__text--name"></div>
          <div class="detail-skeleton__line detail-skeleton__line--comment"></div>
          <div class="detail-skeleton__line detail-skeleton__line--comment-short"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonScreen'
};
</script>

<style scoped>
.detail-skeleton {
  width: 755px;
  margin: 0 auto;
  padding-top: 32px;
}

.detail-skeleton__title {
  width: 80%;
  height: 36px;
  margin: 0 auto 20px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e6e6e6 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
}

.detail-skeleton__meta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eeeeee;
}

.detail-skeleton__text {
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e6e6e6 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
}

.detail-skeleton__text--sm {
  width: 100px;
  height: 18px;
}

.detail-skeleton__text--md {
  width: 160px;
  height: 18px;
}

.detail-skeleton__image {
  width: 100%;
  height: 320px;
  margin: 24px 0;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e6e6e6 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
}

.detail-skeleton__content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.detail-skeleton__line {
  width: 100%;
  height: 24px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e6e6e6 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
}

.detail-skeleton__line--short {
  width: 60%;
}

.detail-skeleton__comment-title {
  width: 140px;
  height: 28px;
  margin: 48px 0 16px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e6e6e6 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
}

.detail-skeleton__comments {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.detail-skeleton__comment {
  display: flex;
  gap: 16px;
}

.detail-skeleton__avatar {
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  border-radius: 50%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e6e6e6 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
}

.detail-skeleton__comment-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-skeleton__text--name {
  width: 100px;
  height: 18px;
}

.detail-skeleton__line--comment {
  width: 90%;
  height: 20px;
}

.detail-skeleton__line--comment-short {
  width: 50%;
  height: 20px;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
